import { render, staticRenderFns } from "./trip_report.vue?vue&type=template&id=5054025c&scoped=true"
import script from "./trip_report.vue?vue&type=script&lang=js"
export * from "./trip_report.vue?vue&type=script&lang=js"
import style0 from "./trip_report.vue?vue&type=style&index=0&id=5054025c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054025c",
  null
  
)

export default component.exports